import { ElementFrame } from '../data/slides';

/** Reference slide canvas size — matches PitchCard / SlideCanvas aspect ratio. */
export const SLIDE_CANVAS_WIDTH = 920;
export const SLIDE_CANVAS_HEIGHT = 520;

export const frameToPixels = (frame: ElementFrame) => ({
  width: (frame.w / 100) * SLIDE_CANVAS_WIDTH,
  height: (frame.h / 100) * SLIDE_CANVAS_HEIGHT,
});

/** Largest uniform corner radius before the shape becomes fully rounded. */
export const maxImageCornerRadius = (frame?: ElementFrame): number => {
  if (!frame) {
    return Math.round(Math.min(SLIDE_CANVAS_WIDTH, SLIDE_CANVAS_HEIGHT) / 2);
  }
  const { width, height } = frameToPixels(frame);
  return Math.max(0, Math.round(Math.min(width, height) / 2));
};

export const clampImageCornerRadius = (radius: number, frame?: ElementFrame): number =>
  Math.min(Math.max(0, radius), maxImageCornerRadius(frame));
